import { COLORS } from "@/constants/Colors/colors";
import { Box, Button, IconButton, Typography } from "@mui/material";
import { useState } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import useCustomQuery from "@/hooks/useCustomQuery";
import { HashLoader } from "react-spinners";
import { ModuleVideo } from "./ModuleVideo/ModuleVideo";
import { ModuleFile } from "./ModuleFile/ModuleFile";
import { ModuleExam } from "./ModuleExam/ModuleExam";
import { ModuleHomework } from "./ModuleHomework/ModuleHomework";
import { Add } from "./Add/Add";
import DeleteDialog from "../DeleteDialog";
import EditModule from "../EditModule";
import { useSelector } from "react-redux";

export default function ModuleDetailsCollapse({ module, index, course }) {
  const language = useSelector((state) => state?.global);
  const lang = language?.lang;
  const globalState = useSelector((state) => state?.global);
  const [collapse, setCollapse] = useState(true);
  const { data, isPending } = useCustomQuery({
    enabled: !collapse,
    url: `module/adminShow?id=${module?.id}`,
    key: ["module", module, lang],
    retry: false,
    lang,
  });

  const {
    data: files,
    isPending: isFilesPending,
    isError: isFilesError,
  } = useCustomQuery({
    url: `drive?type=module&id=${module?.id}`,
    key: ["module files", module?.id, lang],
    // data: { type: "module", id: module?.id },
    retry: false,
    enabled: !isNaN(+module?.id) && !collapse,
    lang,
  });

  // console.log(`files`, files?.data);

  const {
    data: exams,
    isPending: isExamsPending,
    isError: isExamsError,
  } = useCustomQuery({
    url: `exam/getLessonExamsAdmin?lesson_module_id=${module?.id}`,
    key: ["module exam", module?.id, lang],
    enabled: !collapse,
    retry: false,
    lang,
  });
  const {
    data: homework,
    isPending: isHomeworkPending,
    isError: isHomeworkError,
  } = useCustomQuery({
    url: `homeWork/getHomeWorkAdmin?lesson_module_id=${module?.id}`,
    key: ["module homework", module?.id, lang],
    enabled: !collapse,
    retry: false,
    lang,
  });

  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const [deleteData, setDeleteData] = useState();
  const [deleteName, setDeleteName] = useState();
  const [confirmMessage, setConfirmMessage] = useState("");
  const deleteModuleHandler = (module) => {
    setIsConfirmOpen(true);
    setConfirmMessage(
      lang == "ar"
        ? "هل انت متأكد من حذف الحصه"
        : "Are you sure you want to delete the Lesson?"
    );
    setDeleteData(module);

    // setDeleteName(module?.id);
  };

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        flexWrap: "wrap",
      }}
    >
      <Box
        onClick={() => setCollapse(!collapse)}
        sx={{
          width: "100%",
          height: "100%",
          bgcolor: COLORS.BOX,
          cursor: "pointer",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          paddingLeft: 2,
          backgroundColor: globalState?.isDarkMode
            ? COLORS.SOFT_DARK
            : COLORS.BOX,
        }}
      >
        <Box
          sx={{
            display: "flex",
            height: "100%",
            alignItems: "center",
          }}
        >
          <Typography
            width={50}
            minHeight={165}
            bgcolor={COLORS.SOFT_DARK}
            color={COLORS.WHITE}
            fontSize={20}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexWrap: "wrap",
            }}
          >
            {index < 9 ? "0" + (index + 1) : index + 1}
          </Typography>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 1,
              paddingY: 2,
              marginRight: 2,
              wordBreak: "break-word",
            }}
          >
            <Typography fontSize={20} fontFamily={"Noor-bold"}>
              {module?.name}
            </Typography>
            <Typography fontSize={18}>{module?.overview}</Typography>
          </Box>
        </Box>
        <Box
          sx={{ height: "100%", display: "flex", alignItems: "center", gap: 2 }}
        >
          <Typography fontFamily={"Noor-bold"} fontSize={20} marginLeft={2}>
            {+module.price > 0
              ? module.price + lang == "ar"
                ? " جنيه"
                : "EGP"
              : lang == "ar"
              ? "مجاني"
              : "Free"}
          </Typography>
          <Button
            sx={{
              bgcolor: COLORS.PRIMARY.MAIN,
              color: COLORS.WHITE,
              "&:hover": { color: COLORS.PRIMARY.MAIN },
            }}
          >
            {collapse
              ? lang == "ar"
                ? "إظهار"
                : "Show"
              : lang == "ar"
              ? "إخفاء"
              : "Hidden"}
          </Button>
          {/* <IconButton
            sx={{ bgcolor: "#01c46e", "&:hover": { bgcolor: "#01c46e" } }}
            // onClick={() => setModuleIsOpen(true)}
          >
            <EditIcon fontSize="small" />
          </IconButton> */}

          <EditModule course={course} module={module} />
          <IconButton
            sx={{
              bgcolor: COLORS.DANGER,
              "&:hover": { bgcolor: COLORS.DANGER },
            }}
            onClick={() => {
              deleteModuleHandler(module);
            }}
          >
            <DeleteIcon fontSize="small" />
          </IconButton>
          <DeleteDialog
            isConfirmOpen={isConfirmOpen}
            setIsConfirmOpen={setIsConfirmOpen}
            deleteName={deleteName}
            deleteData={deleteData}
            confirmMessage={confirmMessage}
          />
        </Box>
      </Box>
      <Box
        sx={{
          width: "100%",
          bgcolor: COLORS.DARK_GRAY,
          height: collapse ? 0 : "auto",
          minHeight: collapse ? 0 : 50,
          overflow: "hidden",
          msTransitionTimingFunction: "linear",
          backgroundColor: globalState?.isDarkMode ? "#3f3f3c" : COLORS.WHITE,
        }}
      >
        {isPending && isFilesPending && isExamsPending && isHomeworkPending ? (
          <Box
            sx={{
              width: "100%",
              height: 50,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <HashLoader size={20} color={COLORS.PRIMARY.MAIN} />
          </Box>
        ) : (
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              gap: 2,
              paddingY: 2,
            }}
          >
            <Add module={module} homework={homework} exams={exams} />
            {data?.data?.lessons?.map((item, index) => (
              <ModuleVideo video={item} key={index} show={!collapse} />
            ))}
            {!isFilesError &&
              !isFilesPending &&
              files?.data?.map((item, index) => (
                <ModuleFile id={module?.id} file={item} key={index} />
              ))}
            {!isExamsError && !isExamsPending && (
              <>
                <ModuleExam exam={exams?.data} module={module} />
              </>
            )}
            {!isHomeworkError && !isHomeworkPending && (
              <ModuleHomework homework={homework?.data} />
            )}
          </Box>
        )}
      </Box>
    </Box>
  );
}
